__turbopack_context__.v({
  "className": "instrument_serif_fdfd4b25-module__DaDjAq__className",
  "variable": "instrument_serif_fdfd4b25-module__DaDjAq__variable",
});
